<template>   
    <b-row class="slide-body">
           
        <b-row align-h="center" class="pt-2">   
            <h1 style="color:#ffffff"><strong>{{ $t('slide27.text1') }}</strong></h1>
        </b-row>

        <b-row align-h="center" class="pb-2 pt-2">   
            <h3 style="color:#ffffff">{{ $t('slide27.text2') }}</h3>
        </b-row>
        <b-row align-h="around">  
            <b-col cols="4">
                <h3 style="color:#ffffff"><strong>{{ $t('slide27.text5') }}</strong></h3> 
                <b-img  src="@/images/program1.png" fluid @click="modalShowProgram1=true"></b-img>

                <b-modal v-model="modalShowProgram1" ok-only ok-variant="secondary" :ok-title="$t('slide27.text10')">
                    <form role="form" method="post">
                        <div class="form-group"> 
                            <label><p>{{ $t('slide27.text5') }}</p></label>                           
                            <video controls :src="videoLoad1" autoplay width="100%"></video>
                        </div>
                    </form>
                </b-modal>

            </b-col>
            <b-col cols="4">
                <h3 style="color:#ffffff"><strong>{{ $t('slide27.text6') }}</strong></h3> 
                <b-img  src="@/images/program2.png" fluid @click="modalShowProgram2=true"></b-img>
                <b-modal v-model="modalShowProgram2" ok-only ok-variant="secondary" :ok-title="$t('slide27.text10')">
                    <form role="form" method="post">
                        <div class="form-group"> 
                            <label><p>{{ $t('slide27.text6') }}</p></label>                           
                            <video controls :src="videoLoad2" autoplay width="100%"></video>
                        </div>
                    </form>
                </b-modal>                
            </b-col>
            <b-col cols="4">
                <h3 style="color:#ffffff"><strong>{{ $t('slide27.text7') }}</strong></h3> 
                <b-img  src="@/images/program3.png" fluid @click="modalShowProgram3=true"></b-img>
                <b-modal v-model="modalShowProgram3" ok-only ok-variant="secondary" :ok-title="$t('slide27.text10')">
                    <form role="form" method="post">
                        <div class="form-group"> 
                            <label><p>{{ $t('slide27.text7') }}</p></label>                           
                            <video controls :src="videoLoad3" autoplay width="100%"></video>
                        </div>
                    </form>
                </b-modal>
            </b-col>
        </b-row>
        <b-row align-h="center" class="pt-2">   
            <h1 style="color:#ffffff"><strong>{{ $t('slide27.text8') }}</strong></h1>            
        </b-row>
        <b-row align-h="center" class="pb-2">               
            <h3 style="color:#ffffff">{{ $t('slide27.text4') }}</h3>
        </b-row> 
        <b-row align-h="around">
            <b-col cols="4">
                
                <b-button variant="success" @click="selectedProgram1=true"><h4><strong>{{ $t('slide27.text5') }}</strong></h4></b-button>
                <h5 v-if="selectedProgram1" style="color:orange"><strong>{{ $t('slide27.text11') }}</strong></h5>
            </b-col>
            <b-col cols="4">
                <b-button variant="success" @click="goToSlide('slide29')"><h4><strong>{{ $t('slide27.text6') }}</strong></h4></b-button>
            </b-col>
            <b-col cols="4">
                <b-button variant="success"  @click="selectedProgram3=true"><h4><strong>{{ $t('slide27.text7') }}</strong></h4></b-button>
                <h5 v-if="selectedProgram3" style="color:orange"><strong>{{ $t('slide27.text11') }}</strong></h5>
            </b-col>
        </b-row>  
    </b-row> 
</template>

<script>
import {mapState} from 'vuex';

export default { 
    props:['lang'],
    data() {
        return {
            video1: {
                es: require('@/videos/es_slide27_programa1.mp4'),
                ca: require('@/videos/ca_slide27_programa1.mp4')
            },
            video2: {
                es: require('@/videos/es_slide27_programa2.mp4'),
                ca: require('@/videos/ca_slide27_programa2.mp4')
            },
            video3: {
                es: require('@/videos/es_slide27_programa3.mp4'),
                ca: require('@/videos/ca_slide27_programa3.mp4')
            },
            modalShowProgram1: false,
            modalShowProgram2: false,
            modalShowProgram3: false,
            selectedProgram1:false,
            selectedProgram3:false

        }
    },
    computed: {
        ...mapState(['showMenu']),
        videoLoad1(){            
            return this.video1[this.$i18n.locale];
        },
        videoLoad2(){            
            return this.video2[this.$i18n.locale];
        },
        videoLoad3(){            
            return this.video3[this.$i18n.locale];
        },

            
    },
    methods:{
         goToSlide(slide){
            this.$router.push({name:slide,params:{lang:this.lang}});
        },
    },
    beforeCreate(){
        this.$store.dispatch('changeShowMenu',true);
    },
    created(){
        this.$i18n.locale=this.lang;
    }      
}
</script>


<style scoped>

    .row{
        margin-left: 0px;
        margin-right: 0px;  
        position:relative; 
        width: 100%; 
    }

    img {
        max-width: 100%;
        height: auto;
    }

    .btn-circle{
        width:100px;
        height: 100px;
        padding: 6px 0px;
        border-radius: 50px;
        text-align: center;
        background-color:forestgreen;
        line-height: 1.4;
        border-color:black;        
    }

</style>